import GiveAwayHelp from "./GiveAwayHelp";
import PublicationSuccess from "./PublicationSuccess";

const createGiveAway = [
    {
        title: 'Enter your ad text',
        progress: { title: 'Give away', step: 2 },
        component: GiveAwayHelp, valid: true, required: true,
    },
    {
        progress: { title: 'Thank you', step: 3 },
        component: PublicationSuccess, valid: true, required: true,
    },
];

export default createGiveAway;
